import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, User, Heart, Sparkles, Award } from 'lucide-react';
const testimonials = [{
  name: 'María González',
  location: 'Miami, USA 🇺🇸',
  avatar: 'M',
  rating: 5,
  text: 'Mi Frenchie tenía gases terribles. En 4 días ya noté la diferencia. Ahora su digestión es mucho mejor y ya no huele tan mal la casa.',
  highlight: 'Gases reducidos en 4 días',
  icon: Sparkles
}, {
  name: 'Carlos Restrepo',
  location: 'Medellín, Colombia 🇨🇴',
  avatar: 'C',
  rating: 5,
  text: 'El meal prep me cambió la vida. Antes improvisaba cada día, ahora tengo todo listo en 20 minutos los domingos. Super práctico.',
  highlight: 'Ahorro de tiempo semanal',
  icon: Award
}, {
  name: 'Ana Martínez',
  location: 'Ciudad de México, México 🇲🇽',
  avatar: 'A',
  rating: 5,
  text: 'La calculadora de porciones es oro. Mi Bruno bajó 1kg que le sobraba y tiene más energía que nunca. Vale cada peso.',
  highlight: 'Peso ideal alcanzado',
  icon: Heart
}, {
  name: 'Roberto Andrade',
  location: 'Quito, Ecuador 🇪🇨',
  avatar: 'R',
  rating: 5,
  text: 'Probé mil cosas para la piel de mi Frenchie. La rutina de 7 minutos del bono fue lo único que funcionó. Increíble.',
  highlight: 'Piel sana y brillante',
  icon: Sparkles
}, {
  name: 'Laura Fernández',
  location: 'Buenos Aires, Argentina 🇦🇷',
  avatar: 'L',
  rating: 5,
  text: 'Tenía miedo de darle toppers por si le caían mal. La guía me dio la confianza de variar su comida de forma segura.',
  highlight: 'Variedad sin riesgos',
  icon: Award
}, {
  name: 'Diego Moreno',
  location: 'Madrid, España 🇪🇸',
  avatar: 'D',
  rating: 5,
  text: 'El plan anti gases salvó mis noches. Mi Coco ya no tiene esos episodios de malestar. Duerme tranquilo y yo también.',
  highlight: 'Noches tranquilas',
  icon: Heart
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-239">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#FAE8FF]/50 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-240" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-[#F5D0FE]/30 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-241" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-243">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#D946EF]/10 text-[#A21CAF] text-sm font-semibold mb-4" data-id="element-244">
            <Star className="w-4 h-4 fill-current" data-id="element-245" />
            Más de 500 dueños satisfechos
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-4" data-id="element-246">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-[#666666] max-w-lg mx-auto" data-id="element-247">
            Resultados reales de dueños de Frenchies que transformaron la
            alimentación de sus peludos.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-248">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gradient-to-br from-white to-[#FDF4FF] rounded-2xl p-6 shadow-lg border border-[#F5D0FE]/30 relative group" data-id="element-249">
              {/* Quote icon */}
              <div className="absolute top-4 right-4 text-[#F5D0FE]" data-id="element-250">
                <Quote className="w-8 h-8" data-id="element-251" />
              </div>

              {/* Header */}
              <div className="flex items-center gap-4 mb-4" data-id="element-252">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#D946EF] to-[#A21CAF] flex items-center justify-center text-white font-bold text-lg shadow-lg" data-id="element-253">
                  {testimonial.avatar}
                </div>
                <div data-id="element-254">
                  <h4 className="font-bold text-[#2D2D2D]" data-id="element-255">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-[#666666]" data-id="element-256">
                    {testimonial.location}
                  </p>
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-3" data-id="element-257">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-258" />)}
              </div>

              {/* Text */}
              <p className="text-[#4A4A4A] text-sm leading-relaxed mb-4" data-id="element-259">
                "{testimonial.text}"
              </p>

              {/* Highlight badge */}
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#D946EF]/10 text-[#A21CAF] text-xs font-semibold" data-id="element-260">
                <testimonial.icon className="w-3.5 h-3.5" data-id="element-261" />
                {testimonial.highlight}
              </div>
            </motion.div>)}
        </div>

        {/* Trust indicators */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10" data-id="element-262">
          <div className="flex items-center gap-2 text-[#666666]" data-id="element-263">
            <div className="flex -space-x-2" data-id="element-264">
              {['M', 'C', 'A', 'R'].map((letter, i) => <div key={i} className="w-8 h-8 rounded-full bg-gradient-to-br from-[#D946EF] to-[#A21CAF] flex items-center justify-center text-white text-xs font-bold border-2 border-white" data-id="element-265">
                  {letter}
                </div>)}
            </div>
            <span className="text-sm font-medium" data-id="element-266">+500 clientes felices</span>
          </div>

          <div className="flex items-center gap-2" data-id="element-267">
            <div className="flex gap-0.5" data-id="element-268">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-269" />)}
            </div>
            <span className="text-sm font-medium text-[#666666]" data-id="element-270">
              4.9/5 valoración promedio
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}